import { success, failure, Result } from '../shared'
import { TranslationsProvider } from './translations.provider'
import { TranslationsServiceErrorCodes } from './translations.types'

export class TranslationsService {
  constructor(private provider: TranslationsProvider) {}

  public async get(): Promise<Result<any>> {
    try {
      const { data } = await this.provider.get()
      return success(data)
    } catch (error) {
      if (error.hasOwnProperty('response')) {
        return failure(TranslationsServiceErrorCodes.CANNOT_LOAD_FILE)
      }

      if (error instanceof SyntaxError) {
        return failure(TranslationsServiceErrorCodes.CANNOT_PARSE_JSON)
      }

      return failure(TranslationsServiceErrorCodes.GENERIC)
    }
  }
}
